
import { cn } from "@/lib/utils";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> { }

export function Container({ className, ...props }: ContainerProps) {
    return (
        <div
            className={cn("mx-auto max-w-7xl px-6 lg:px-8", className)}
            {...props}
        />
    );
}
